import React from 'react';

import { useSelector } from 'react-redux';

import { BUTTON_SUBSCRIBE } from 'config/testID';

import { selectLayoutConfig } from 'store/config/selectors';

import { isTabletOrWeb } from 'utils/responsiveness';

import styles from 'screens/Detail/components/DetailPageButtons/styles';

import ActionButton from 'components/CustomButtons/ActionButton';

import DetailPageSubscribeModal from '../DetailPageSubscribeModal/DetailPageSubscribeModal';

type DetailPageSubscribeButtonProps = {
    isModalOpen: boolean;
    ableToPlayVod: boolean;
    onCloseModal(): void;
    onOpenModal(): void;
};

function DetailPageSubscribeButton({
    isModalOpen,
    onOpenModal,
    onCloseModal,
    ableToPlayVod,
}: DetailPageSubscribeButtonProps) {
    const { primary } = useSelector(selectLayoutConfig);

    return (
        <>
            <DetailPageSubscribeModal
                isModalOpen={isModalOpen}
                onCloseModal={onCloseModal}
            />
            <ActionButton
                numberOfLines={1}
                buttonStyle={[
                    styles.button,
                    styles.watchButton,
                    ableToPlayVod && styles.borderedButton,
                    isTabletOrWeb && styles.buttonNonScaling,
                ]}
                buttonTextStyle={
                    ableToPlayVod
                        ? styles.transparentButtonText
                        : styles.buttonText
                }
                title={BUTTON_SUBSCRIBE}
                fillColor={ableToPlayVod ? 'transparent' : primary}
                onPress={onOpenModal}
            />
        </>
    );
}

export default DetailPageSubscribeButton;
